import { FC, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from '../../utils/axios';

// Opens the public invoice / receipt view from an SMS short link.
const InvoiceShortLink: FC<{ receipt?: boolean }> = ({ receipt }) => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [invalid, setInvalid] = useState(false);

  useEffect(() => {
    axios.get(`/api/v1/invoice/short/${code}`)
      .then((res: any) => {
        const token = receipt ? res.data.dispatchReceiptToken : res.data.dispatchToken;
        if (!token) return setInvalid(true);
        navigate(receipt ? `/invoice-payment-receipt/${token}/view` : `/invoice/${token}/view`, { replace: true });
      })
      .catch(() => setInvalid(true));
  }, [code]);

  return invalid ? <p style={{ padding: 24 }}>This link is invalid or has expired.</p> : null;
};

export default InvoiceShortLink;
